export enum CustomerBoxColumn {
  Name = 'name',
  Version = 'version',
  OS = 'OS',
  State = 'state',
  IPv4 = 'ipv4',
  Actions = 'actions',
}

export namespace CustomerBoxColumn {
  export const allColumns: string[] = [
    CustomerBoxColumn.Name,
    CustomerBoxColumn.Version,
    CustomerBoxColumn.OS,
    CustomerBoxColumn.State,
    CustomerBoxColumn.IPv4,
  ];

  export const displayedColumns: string[] = [
    CustomerBoxColumn.Name,
    CustomerBoxColumn.OS,
    CustomerBoxColumn.State,
    CustomerBoxColumn.IPv4,
  ];

  export const translateKey = (column: string): string => {
    switch (column) {
      case CustomerBoxColumn.Name:
        return 'boxes.columns.name';
      case CustomerBoxColumn.Version:
        return 'boxes.columns.version';
      case CustomerBoxColumn.OS:
        return 'boxes.columns.operatingSystem';
      case CustomerBoxColumn.State:
        return 'boxes.columns.state';
      case CustomerBoxColumn.IPv4:
        return 'boxes.columns.ipv4';
      case CustomerBoxColumn.Actions:
        return 'boxes.columns.actions';
      default:
        return '';
    }
  };

  export const sortField = (column: string): string => {
    switch (column) {
      case CustomerBoxColumn.Name:
        return 'name';
      case CustomerBoxColumn.Version:
        return 'version';
      case CustomerBoxColumn.OS:
        return 'os';
      case CustomerBoxColumn.State:
        return 'state';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
